export default __webpack_public_path__ + "static/media/desktop-header-logo.40666536.png";